import { ShippingOptions } from './checkoutState';

const getAvailableDeliveryTypes = (shippingOptions: ShippingOptions) =>
  Object.entries({
    homeDelivery: !!shippingOptions.homeDelivery?.filter(({ isDisabled }) => !isDisabled).length,
    collectionPoint: !!shippingOptions.collectionPointDelivery?.filter(
      ({ isDisabled, carrierGroupKey }) => !isDisabled && carrierGroupKey !== 'generic'
    ).length,
    storePickup: !!shippingOptions.collectionPointDelivery?.filter(
      ({ isDisabled, carrierGroupKey }) => !isDisabled && carrierGroupKey === 'generic'
    ).length,
  })
    .filter(([, value]) => !!value)
    .map(([key]) => key);

export default getAvailableDeliveryTypes;
